'use client';

import type {PropsWithChildren} from 'react';
import {
	Accordion,
	AccordionContent,
	AccordionItem,
	AccordionTrigger,
} from '@radix-ui/react-accordion';
import clsx from 'clsx';
import {ChevronDown, SlidersHorizontal} from 'lucide-react';

type Props = PropsWithChildren;

export const FilterAccordion = ({children}: Props) => {
	return (
		<Accordion
			type="single"
			collapsible
			className={clsx('bg-neutral-100/10', 'rounded-sm', 'overflow-hidden')}
		>
			<AccordionItem value="filters">
				<AccordionTrigger
					className={clsx(
						'cursor-pointer',
						'p-4',
						'w-full',
						'flex',
						// 'justify-end',
						'gap-4',
						'data-[state=open]:[&>svg]:rotate-180',
						'data-[state=open]:bg-neutral-800',
						'transition-transform',
						'hover:bg-neutral-800',
						'transition-colors!',
					)}
				>
					<ChevronDown size={24} aria-hidden className="transition-transform" />
					<span className={clsx('flex', 'items-center', 'leading-1', 'gap-2')}>
						<SlidersHorizontal size={20} aria-hidden />
						Filter
					</span>
				</AccordionTrigger>

				<AccordionContent
					className={clsx(
						'p-4',
						'data-[state=closed]:animate-accordion-up',
						'data-[state=open]:animate-accordion-down',
						'overflow-hidden',
					)}
				>
					{children}
				</AccordionContent>
			</AccordionItem>
		</Accordion>
	);
};
